import { render } from "./FormTemplates.vue?vue&type=template&id=7769275a&ts=true"
import script from "./FormTemplates.vue?vue&type=script&lang=ts"
export * from "./FormTemplates.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__